var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2759_1068)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C18.6274 0 24 5.37262 24 12C24 18.1351 19.3957 23.1943 13.454 23.912V15.6669H16.7001L17.3735 12L17.3734 12H13.454V10.7031C13.454 8.76526 14.2141 8.01995 16.1817 8.01995C16.2199 8.01995 16.2576 8.02 16.2948 8.02011C16.3898 8.02041 16.4816 8.02109 16.5699 8.02215C17.0009 8.02732 17.3477 8.04155 17.568 8.06475V8.06456C17.568 8.06457 17.5681 8.06457 17.5681 8.06457V4.74057C17.5681 4.74057 17.568 4.74057 17.568 4.74056C17.4973 4.72089 17.413 4.70122 17.3184 4.68189C16.6951 4.55462 15.6194 4.44226 14.9594 4.44226C13.0171 4.44226 11.5819 4.88647 10.6183 5.80876C10.5872 5.83851 10.5566 5.86876 10.5265 5.8995C9.56316 6.88331 9.10106 8.37769 9.10106 10.4199V12H6.62663V15.6669H6.62671V15.6669H9.10106V23.6466C3.87431 22.3498 0 17.6278 0 12C0 5.37262 5.37262 0 12 0Z",
    fill: "#2A2A2A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2759_1068"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.2bd53a66aa13803f38c66255c3aab310.svg";
export { ForwardRef as ReactComponent };